const getConfig = state => state.configState.config.config;
const isLoaded = state => state.configState.config.isLoaded;
const getAge = state => state.configState.config.age;

export default {
  getConfig,
  isLoaded,
  getAge
};
